/**
 * Geht in der App etwas schief, erscheint die Fehlerseite mit der Schlange
 * (features/error-page.ts) – mit einem ehrlichen Text, dem Weg zurueck
 * ("Neu laden") und Snake als kleinem Umweg.
 *
 * Nur fuer echte Fehler aus dem eigenen Code: Meldungen von
 * Browser-Erweiterungen, fremden Skripten und bekannte harmlose Meldungen
 * (z. B. ResizeObserver) loesen nichts aus. Hoechstens einmal je
 * Seitenaufruf – niemand soll in einer Snake-Schleife landen.
 *
 * Zum Testen: Admin → Diagnose → „Fehlerseite testen“. Das loest einen
 * echten (harmlosen) Fehler aus; nach dem Neuladen ist alles wie vorher.
 */
import { showErrorOverlay } from './error-page.ts';

let shown = false;

const HARMLESS = [/ResizeObserver loop/i, /^Script error\.?$/i, /AbortError/i, /The user aborted/i, /cancelled-popup-request/i, /popup-closed-by-user/i];

function isOwnScript(filename: string | undefined): boolean {
  if (!filename) return true;
  try {
    return new URL(filename, location.href).origin === location.origin;
  } catch {
    return false;
  }
}

export function showErrorSnake(detail: string, test = false): void {
  showErrorOverlay(detail, { test });
}

/** Einmal beim Start, nach installErrorLog(). */
export function installErrorSnake(): void {
  const handle = (message: string, filename?: string) => {
    if (shown) return;
    if (HARMLESS.some((re) => re.test(message))) return;
    if (!isOwnScript(filename)) return;
    shown = true;
    showErrorSnake(message, message.includes('[Snake-Test]'));
  };
  window.addEventListener('error', (ev) => handle(ev.message || String(ev.error), ev.filename));
  window.addEventListener('unhandledrejection', (ev) => {
    const reason = ev.reason as { message?: string; code?: string; name?: string } | undefined;
    if (reason?.name === 'AbortError') return;
    handle(reason?.message ?? reason?.code ?? String(ev.reason));
  });
}

/** Loest einen echten, harmlosen Fehler aus – fuer den Test im Admin-Bereich. */
export function triggerTestError(): void {
  shown = false;
  window.setTimeout(() => {
    throw new Error('[Snake-Test] Absichtlicher Testfehler aus dem Admin-Bereich – es ist nichts kaputt.');
  }, 0);
}
